/* eslint-disable @typescript-eslint/no-explicit-any */
import { decorators } from '@orange-marmalade/paginate-this'
import select from './selectors'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function lazyDrive<T extends React.ComponentType<any>>(Comp: T) {
    return decorators.decorate(Comp, props => select(props.paginator).lazyDrive())
}
